import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { IoThermometerOutline, IoWaterOutline } from "react-icons/io5";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


const Dashboard = () => {
    const { user } = useSelector((state) => state.auth)
    const [sensor, setSensor] = useState([])
    const [datas, setDatas] = useState([])

    axios.defaults.withCredentials = true;



    const getSensor = async () => {
        const response = await axios.get('https://ayres-iot-backend.cyclic.app/sensors/newest');
        setSensor(response.data)
    }

    const getDatas = async () => {
        const response = await axios.get('https://ayres-iot-backend.cyclic.app/sensors/ten');
        setDatas(response.data);
    }
    //https://javascript.plainenglish.io/create-a-chart-with-react-and-chart-js-32d3f142b43f

    const data = {
        labels: datas.map((data) => String(data.createdAt).substring(11, 19)),
        datasets: [
            {
                label: 'Temperature',
                data: datas.map((data) => data.temperature),
                fill: false,
                borderColor: 'rgb(10, 192, 10)',
                tension: 0.1
            },
            {
                label: 'Humidity',
                data: datas.map((data) => data.humidity),
                fill: false,
                borderColor: 'hsl(204, 86%, 53%)',
                tension: 0.1
            }
        ]
    };


    useEffect(() => {

        getDatas()
        getSensor()
        //https://codesandbox.io/s/23f10?file=/src/App.js:426-528
        //untuk auto refresh data
        const interval = setInterval(() => {

            getDatas()
            getSensor()

        }, 10000)
        return () => clearInterval(interval)
    }, [])





    //https://codepen.io/emkelley/pen/pVrGxX
    return (
        sensor.map((sensor) => (

            <div>

                <section className="hero is-info welcome is-small">
                    <div className="hero-body">
                        <div className="container">
                            <h1 className="title">
                                Hello, {user && user.name}.
                            </h1>
                            <h2 className="subtitle">
                                I hope you are having a great day!
                            </h2>
                        </div>
                    </div>
                </section>
                <section className="info-tiles has-text-">
                    <div className="tile is-ancestor has-text-centered">
                        <div className="tile is-parent">
                            <article className="tile is-child box">
                                <p className="title">{sensor.temperature} &#176;C</p>
                                <progress className="progress is-large my-5 is-success" value={sensor.temperature} max="100">{sensor.humidity}</progress>
                                <p className="subtitle"><IoThermometerOutline />Temperature</p>
                            </article>
                        </div>
                        <div className="tile is-parent">
                            <article className="tile is-child box">
                                <p className="title">{sensor.humidity} %H</p>
                                <progress className="progress is-large my-5 is-info" value={sensor.humidity} max="100">{sensor.humidity}</progress>
                                <p className="subtitle"><IoWaterOutline />Humidity</p>
                            </article>
                        </div>
                    </div>
                    <div className="tile is-ancestor has-text-centered">
                        <div className="tile is-parent">
                            <article className="tile is-child box">
                                <p className="title">Current Condition</p>
                                <p className="subtitle">Rescubator Monitoring</p>
                                <Line
                                    data={data}
                                    options={{
                                        responsive: true,

                                    }}
                                />
                            </article>
                        </div>
                    </div>
                </section>
            </div>


        ))



    )
}

export default Dashboard    